import UserList from "../../../../User/components/user-listing/components/index";
import ProviderHeader from "../../provider-header/components/index";

const ProviderUserList = () => {
    return (
    <div>
        <ProviderHeader />
      <UserList />
      
    </div>
  );
};

export default ProviderUserList;
